
import React from 'react';

interface ValuePropsSectionProps {
  onPromptClick: (prompt: string) => void;
  onLoginClick: () => void;
}

interface FeatureCardProps {
  title: string;
  description: string;
  example: string;
  cta: string;
  onCtaClick: () => void;
}

const FeatureCard: React.FC<FeatureCardProps> = ({ title, description, example, cta, onCtaClick }) => (
  <div className="flex-1 flex flex-col p-2 sm:p-3 rounded-2xl border border-primary-100 bg-white shadow-[0_12px_16px_0_rgba(225,215,201,0.16)] min-w-0">
    <div className="flex flex-col gap-1 mb-2 sm:mb-3">
      <h3 className="text-lg sm:text-xl font-medium text-grayscale-1200 break-words">{title}</h3>
      <p className="text-sm sm:text-base md:text-sm text-black/70 font-grotesk break-words">{description}</p>
    </div>
    <div className="flex-grow flex flex-col justify-between mt-auto p-2 sm:p-3 rounded-lg border border-primary-100 bg-primary-100/30 min-w-0">
        <p className="text-sm sm:text-base md:text-sm italic text-grayscale-1100 font-grotesk min-h-[60px] break-words">{example}</p>
        <button onClick={onCtaClick} className="text-xs sm:text-sm md:text-xs font-bold text-primary-600 underline self-start mt-2 whitespace-nowrap">
            {cta}
        </button>
    </div>
  </div>
);

const ValuePropsSection: React.FC<ValuePropsSectionProps> = ({ onPromptClick, onLoginClick }) => {
  // const features = [
  //   { title: 'Solve', description: 'a technical problem', example: 'Show me technologies that capture and remove microplastics from water', cta: 'Try it now' },
  //   { title: 'Benchmark', description: 'your technologies', example: 'How does our current carbon capture pipeline compare to MIT’s', cta: 'Try it now' },
  //   { title: 'Landscape', description: 'technical field', example: 'Who are the zinc iodine battery researchers in the US working at TRL 6', cta: 'Try it now' },
  //   { title: 'Connect', description: 'with the TTO', example: 'Message decision makers to explore licensing opportunities', cta: 'Login' }
  // ];

  const features = [
    { title: 'Case Study 1', description: '', example: 'A $30B engineering group identified 24 licensable technologies across 4 countries for wastewater and organic waste treatment.', cta: '' },
    { title: 'Case Study 2', description: '', example: 'Nutraceuticals market leader sourced ready to licence plant based formulation for knee pain.', cta: '' },
    { title: 'Case Study 3', description: '', example: 'A fast growing mid-sized remote patient monitoring company matched with a top-ranked Indian research institute.', cta: '' },
    { title: 'Case Study 4', description: '', example: 'Strategic partnership with a German technology-transfer pioneer, unlocking 10,000+ industry clients across 20 countries.', cta: '' }
  ];

  return (
    <section className="w-full max-w-6xl px-2 sm:px-4 md:px-5 text-center overflow-x-hidden">
      <div className="mb-4 sm:mb-5">
        <h2 className="text-xl sm:text-2xl font-medium text-black uppercase tracking-widest">The smartest path</h2>
        <p className="text-sm sm:text-base text-black/70 font-grotesk">to university technologies, people and insights</p>
      </div>
      <div className="flex flex-col md:flex-row gap-3 sm:gap-4 md:gap-5">
        {features.map((feature, index) => {
           const handleCtaClick = feature.cta === 'Login' ? onLoginClick : () => onPromptClick(feature.example);
           return <FeatureCard key={index} {...feature} onCtaClick={handleCtaClick} />
        })}
      </div>
    </section>
  );
};

export default ValuePropsSection;